import { useRequiredParams } from '@pba/react-router';
import { AppLayout } from 'layouts';
import { PostDetail } from 'features/feed';

type RouteParams = {
  postId: string;
};

const PagePost = () => {
  const { postId } = useRequiredParams<RouteParams>();

  return (
    <AppLayout aside>
      <PostDetail postId={postId} />
    </AppLayout>
  );
};

export default PagePost;
